(function () {
  var nativeFetch = window.fetch;

  function hasRequestedWithHeader(resource, options) {
    var headers =
      (options && options.headers) ||
      (resource && typeof resource !== "string" && resource.headers);
    if (!headers) {
      return false;
    }
    if (typeof headers.get === "function") {
      return !!headers.get("X-Requested-With");
    }
    return Object.keys(headers).some(function (key) {
      return key.toLowerCase() === "x-requested-with";
    });
  }

  function refreshCart() {
    if (window.ajaxCart && typeof window.ajaxCart.load === "function") {
      window.ajaxCart.load(false, true, false, true);
    } else {
      nativeFetch(window.Shopify.routes.root + "cart.js")
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          var countElement = document.getElementById("cart-count");
          if (countElement) {
            countElement.innerHTML = data.item_count;
          }
        })
        .catch(function (error) {
          console.log("personalization cart sync error", error);
        });
    }
  }

  window.fetch = function (resource, options) {
    var url =
      typeof resource === "string"
        ? resource
        : (resource && resource.url) || "";
    var result = nativeFetch.apply(this, arguments);
    if (
      window.general &&
      window.general.enable_cart_drawer &&
      url.indexOf("/cart/add") !== -1 &&
      !hasRequestedWithHeader(resource, options)
    ) {
      result
        .then(function (response) {
          if (response.ok) {
            refreshCart();
          }
        })
        .catch(function () {});
    }
    return result;
  };
})();
